import { createPopper } from './popper'
/**
 * Class DropDown
 */
export default class DropDown {
  constructor (element) {
    this.dropDownElement = document.querySelector(element)
    this.dataAttribe = 'data-dropdown'
    this.offset = [0, 0]
    this.initDropDown()
  }

  /*
    **
    * initialization of drop down
    */
  initDropDown () {
    this.link = this.dropDownElement.querySelector('[' + this.dataAttribe + ']')

    if (this.link !== null) {
      this.content = this.link.nextElementSibling

      this.popperInstance = createPopper(this.link, this.content, {
        placement: 'bottom',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: this.offset
            }
          }
        ]
      })
      this.dropDownElement.addEventListener('click', (e) => {
        e.stopPropagation()
        this.toggle()
      })

      // click outside dropdown
      document.addEventListener('click', e => {
        if (this.link.getAttribute('aria-expanded') === 'true') {
          this.hide()
        }
      })
    }
  }

  /**
  * show dropDown
  */
  show () {
    this.link.classList.add('show')
    this.link.setAttribute('aria-expanded', true)
    this.content.classList.add('show')
    this.popperInstance.update()
  }

  /**
  * hide dropDown
  */
  hide () {
    this.link.setAttribute('aria-expanded', false)
    this.link.classList.remove('show')
    this.content.classList.remove('show')
  }

  /**
   * Toogle dropDown
   */
  toggle () {
    if (this.link.getAttribute('aria-expanded') === 'true') {
      this.hide()
    } else {
      this.show()
    }
  }
}
